import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_CREDITS_APPLIED, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the applied credits as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {boolean} props.isCustomer - Whether the customer is the one using the credits
 * @param {boolean} props.isProvider - Whether the provider is the one using the credits
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemCreditsAppliedMaybe = props => {
  const { lineItems, isCustomer, isProvider, intl } = props;

  const creditsAppliedLineItem = lineItems.find(
    item => item.code === LINE_ITEM_CREDITS_APPLIED && !item.reversal
  );

  // DEBUG: Log credits component logic
  console.log('=== LineItemCreditsAppliedMaybe Debug ===');
  console.log('isCustomer:', isCustomer);
  console.log('lineItems:', lineItems);
  console.log('creditsAppliedLineItem:', creditsAppliedLineItem);
  console.log('Will render credits?', isCustomer && creditsAppliedLineItem);
  console.log('=== End LineItemCreditsAppliedMaybe Debug ===');

  return creditsAppliedLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.creditsApplied" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, creditsAppliedLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemCreditsAppliedMaybe.displayName = 'LineItemCreditsAppliedMaybe';

LineItemCreditsAppliedMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isCustomer: propTypes.bool.isRequired,
  isProvider: propTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemCreditsAppliedMaybe; 